import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import NotFoundPage from 'pages/public/NotFoundPage';

import CreditCardsLists from './CreditCardsLists';
import CreditCardsShow from './CreditCardsShow';

const CreditCards = () => {
  return (
    <Routes>
      <Route index element={<Navigate to="list" replace />} />
      <Route path="list" element={<CreditCardsLists />} />
      <Route path="show/:id" element={<CreditCardsShow />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};

export default CreditCards;
